import { Component, Event, EventEmitter, h, Prop, getAssetPath } from '@stencil/core';
import { ISymplFooterLink } from '../../model';

@Component({
  tag: 'sympl-footer',
  styleUrl: 'sympl-footer.scss',
  shadow: false,
  assetsDirs: ['assets'],
})
export class SymplFooter {
  /** Copyright year */
  @Prop() public year: string;

  /** Footer links */
  @Prop() public links: ISymplFooterLink[] = [];

  /** Emitted when link is clicked */
  @Event() private actionLink: EventEmitter<string>;

  keyboardEvent = (link: string, event: KeyboardEvent): void => {
    if (event.key === 'Enter') {
      this.actionLink.emit(link);
    }
  };

  action = (link: string): void => {
    this.actionLink.emit(link);
  };

  // istanbul ignore next this needs to be tested in e2e
  renderTooltips(args): JSX.Element {
    return <sympl-tooltip class="sympl-dropdown-tooltip" direction="top-start" text={args}></sympl-tooltip>;
  }

  render(): JSX.Element {
    return (
      <div class="sympl-footer">
        <div class="footer-container">
          <div>
            <img class="image" src={getAssetPath('./assets/small-symplr-logo.svg')}></img>
            <span class="c-right">
              {this.links.map((data: ISymplFooterLink) => {
                return (
                  <span>
                    <a
                      class="sympl-action-link"
                      onClick={() => this.action(data.key)}
                      onKeyUp={event => this.keyboardEvent(data.key, event)}
                      tabIndex={0}
                    >
                      {data.text}
                    </a>
                    {this.renderTooltips(data.tooltipText)}
                  </span>
                );
              })}
              <span class="copyright">© {this.year} symplr. All rights reserved.</span>
            </span>
          </div>
        </div>
      </div>
    );
  }
}
